import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const RunnerIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M10.25 3.5C10.9404 3.5 11.5 2.94036 11.5 2.25C11.5 1.55964 10.9404 1 10.25 1C9.55964 1 9 1.55964 9 2.25C9 2.94036 9.55964 3.5 10.25 3.5Z"
		></path>
		<path
			fill="currentColor"
			d="M9.5 4L10.1408 3.91018C10.2282 3.9606 10.308 4.02694 10.377 4.10666L11.6364 5.55971L12.3776 5.27461C12.6838 5.15685 13 5.4198 13 5.79219C13 5.97461 12.921 6.14496 12.7894 6.24614L12.0753 6.79546C11.8039 7.00426 11.4563 7.02923 11.1645 6.86089L9.81818 6.08418V7.15344C9.81818 7.47209 9.94372 7.77346 10.1594 7.97252L11.7497 9.44053C11.9654 9.63959 12.0909 9.94096 12.0909 10.2596V14.4466C12.0909 14.7523 11.8761 15.0002 11.6112 15.0002C11.3667 15.0002 11.1614 14.7881 11.1344 14.5078L10.7915 10.947C10.7523 10.5403 10.5119 10.1971 10.1755 10.0677L9.36339 9.75537C8.76472 9.75537 8.09679 9.42394 7.53654 8.99162C7.51274 8.97325 7.48926 8.9548 7.46609 8.93627C7.23639 8.00161 7.20213 7.01594 7.36771 6.06069L7.52549 5.1504C7.53582 5.09082 7.49633 5.03524 7.44367 5.03524H6.80459C6.69451 5.03524 6.5865 5.06976 6.49211 5.13511L4.84317 6.27666C4.5845 6.45574 4.24845 6.34283 4.11354 6.03151C3.99674 5.76198 4.07217 5.43427 4.28947 5.26711L6.50534 3.56262C6.59204 3.49592 6.68804 3.44693 6.78913 3.41777L8.37296 3.33822C8.526 3.29407 8.94954 3.60465 9.244 3.82057C9.35461 3.90168 9.447 3.96943 9.5 4Z"
		></path>
		<path
			fill="currentColor"
			d="M7.1348 9.94174C7.58084 10.2708 8.12363 10.5749 8.69615 10.7182L7.8184 11.9841C7.64588 12.233 7.38469 12.3778 7.10852 12.3778H3.48284C3.21618 12.3778 3 12.1284 3 11.8207C3 11.5397 3.18133 11.3027 3.42295 11.2679L6.22351 10.8639C6.48567 10.8261 6.7206 10.6586 6.86716 10.405L7.1348 9.94174Z"
		></path>
	</svg>
))
